import { MetadataEntityBase } from '../../abstract-metadata-entity-base';
import { IBizActionEntity } from '../interface-biz-action-entity';
import { AifBizActionType } from '../../aif-biz-action-type';

/**
 * ä¸å¡å¨ä½å®ä½ç±»
 */
export class AifBizActionEntity extends MetadataEntityBase implements IBizActionEntity {
    BizActionType: AifBizActionType;

    BeMetadataId: string;

    BeType: string;

    BizActionAgentMetadataId: string;

    BizActionAgentComponentId: string;

    VoMetadataId: string;

    VoType: string;

    BeId: string;

    VoId: string;

}